export default {
  'zh-CN': {
    title: '复制主题',
    extendType: '复制方式',
    copy: '仅复制主题',
    copyDesc: '复制当前主题样式并创建为新的主题',
    fork: '创建子主题',
    forkDesc: '为当前主题创建子主题，支持父子主题同步',
    disabledTip: '当前主题为继承主题，无法被再次继承',
    forkTip: '支持父主题修改后同步至子主题，支持同步项包括：颜色配置、字体配置、已保存token变量、已定义的开发者模式样式'
  },
  'en-US': {
    title: 'Copy Theme',
    extendType: 'How to copy',
    copy: 'Only copy the theme',
    copyDesc: 'Copy the theme and create a new theme',
    fork: 'Create child theme',
    forkDesc: 'Create a child theme for the current theme, support parent-child theme synchronization',
    disabledTip: 'The current theme is an inherited theme and cannot be inherited again',
    forkTip: 'Support to synchronize the parent theme to the child theme after modification. Supported synchronization items include: color configuration, font configuration, saved token variables, and defined developer mode styles'
  }
};